/**
 * Checks if all elements in array `a` are contained in array `b`
 */
export const arrayHasAll = <T>(a: Array<T>, b: Array<T>) => {
  if (a.length !== b.length) return false
  return a.map((item) => b.includes(item)).find((b) => !b)
}
